export default "__VITE_ASSET__CppnpPdF__"